module.exports = __webpack_public_path__ + "static/WEDDING E&M-138-37b2590b02e6f387933da8a4aa079cac.jpg";